import { View } from "binder"
import { ToolModelManipulationViewModel, ToolModel } from "./toolModelManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ToolModelManipulationView extends View<ToolModelManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-69BF993F-5C49-4E63-A96E-78D9F40E5648"
    }
    loadHtml(): string {
        let element = require('./toolModelManipulation.html').default;
        let style = require('./toolModelManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolModels(v: ToolModel) { this._toolModels = v; } public get toolModels(): ToolModel { return this._toolModels; } private _toolModels: ToolModel;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
